import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';
import { CustomerGroup } from '../../interfaces/interfaces';
import { CustomergroupdeleteComponent } from '../customergroupdelete/customergroupdelete.component';
import { CustomergroupeditorComponent } from '../customergroupeditor/customergroupeditor.component';

@Component({
    selector: 'app-customergroups',
    templateUrl: './customergroups.component.html',
    styleUrls: ['./customergroups.component.scss'],
    providers: [DialogService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomergroupsComponent extends SimpleTableComponent<CustomerGroup> {

    showCustomerGroupEditorModal(customerGroup: CustomerGroup|null = null): void {
        this.dialogService.open(CustomergroupeditorComponent, {
            header: customerGroup !== null ? 'Vevőcsoport szerkesztése - ' + customerGroup.name : 'Vevőcsoport hozzáadása',
            data: {
                customerGroupId: customerGroup !== null ? customerGroup.id : null
            },
            width: '500px'
        }).onClose.pipe(filter((v) => v === true)).subscribe(() => {
            this.refreshTable();
        });
    }

    showCustomerGroupDeleteModal(customerGroup: CustomerGroup): void {
        this.dialogService.open(CustomergroupdeleteComponent, {
            header: 'Vevőcsoport törlése - ' + customerGroup.name,
            data: {
                customerGroupId: customerGroup.id
            }
        }).onClose.pipe(filter((v) => v === true)).subscribe(() => {
            this.refreshTable();
        });
    }

    constructor(
        private apiServiceRef: ApiService,
        private dialogService: DialogService,
        private changeDetectionRef: ChangeDetectorRef
    ) {
        super(changeDetectionRef, apiServiceRef);
        this.endPoint = 'customergroups';
    }
}
